import React from 'react'
import { useTheme } from '@emotion/react'
import { IconTheme } from 'components/patterns/themes/themes'

export type IconType = React.FC<React.PropsWithChildren<IconTheme>>

interface ThemedIconProps {
	Icon: IconType
}

export const ThemedIcon: React.FC<React.PropsWithChildren<ThemedIconProps>> = ({ Icon }) => {
	const { icon } = useTheme()
	return <Icon {...icon} />
}
